import './impersonationBanner.css';

export default function ImpersonationBanner({ impersonatedUser, onExit }) {
  if (!impersonatedUser) return null;

  return (
    <div className="impBanner">
      <span className="impBannerText">
        Viewing as <strong>{impersonatedUser.name}</strong> ({impersonatedUser.email})
      </span>
      <button className="impBannerExit" onClick={onExit}>
        Exit &amp; Return to Admin
      </button>
    </div>
  );
}
